module.exports = __webpack_public_path__ + "img/b_Sink_front.aa7d89a0.jpeg";